import Utils from '../../../../utils/Utils';
import store from '../../../../store';
import { MODAL_CHANGING_EPISODE, showModal } from '../../../../actions/modal';
import { playFullMedia } from '../../../../actions/playmedia';
import EventEmitter from '../../../../utils/EventEmitter';
import { AdsUtils } from 'src/AAF/Ads/Utils';
import {purchaseButtonInfo} from "../../../../requests/loader";
import LayersControl from 'src/utils/LayersControl';

const dataNextSerieEpisode = (next = {}) => {
    return {
        episodeNumber: next.extendedcommon.media.episode.number,
        description: next.description,
        imgSrc: next.image_still,
        seasonNumber: next.extendedcommon.media.episode.season,
        title: next.title,
        groupId: next.id,
        provider: next.proveedor_code,
        serieTitle: next.extendedcommon.media.serie.title,
        episodeTitle: next.title
    };
};

const play = (pbiNextEpisode = {}, next = {}) => {
    const payWayToken = pbiNextEpisode.playButton.payway_token;

    const dataNext = dataNextSerieEpisode(next) || {};

    const { groupId } = dataNext;

    const {
        extendedcommon: { media: { language: { options: { option } = {} } = {} } = {} },
    } = next;

    let languageOptions = null;
    if (Utils.isNotNullOrNotUndefined(option) && Array.isArray(option)) {
        languageOptions = option;
    }

    //this.sendMetric('ver ahora', title);

    const nextDataPlayBack = {
        ispip: false,
        islive: false,
        ispreview: false,
        payway_token: payWayToken,
        resume: 0,
        source: {
            videoid: groupId,
        },
        playerstate: 'PLAYING',
        event: null,
    };

    if (Utils.isNotNullOrNotUndefined(languageOptions)) {
        nextDataPlayBack.languageoptions = languageOptions;
    }
    store.dispatch(showModal({ modalType: MODAL_CHANGING_EPISODE, modalProps: dataNext }));
    AdsUtils.updateStoreAutoChangeEpisode(groupId, payWayToken).then(() => {
      store.dispatch(playFullMedia(nextDataPlayBack));
    }).catch(() => {
      store.dispatch(playFullMedia(nextDataPlayBack));
    });
    EventEmitter.emit('player:episodeChange', { groupId: next.id });

};

export const playNextContent = (next) => {

    purchaseButtonInfo(next.id).then((pbiNextEpisode) => {
      const { playButton: { waspurchased = "0" } = {} } = pbiNextEpisode || {};

      if (waspurchased === '1') {
        // Nos movemos a la siguiente ficha de sig episodio
        play(pbiNextEpisode, next);
        // setTimeout(this.play, 100, next.id, true);
      }else {
        store.dispatch(playFullMedia({
          ispip: false,
          islive: false,
          ispreview: false,
          payway_token: "",
          source: {
              videoid: null,
          },
          playerstate: 'STOPPING',
        }));
        LayersControl.showUX();

      }

    });
};



// WEBPACK FOOTER //
// ./src/components/Modal/functions/ModalEndPlayer/functions.js